"use strict";

exports.__esModule = true;
exports.getElementAtPath = getElementAtPath;
/**
 * Return the element at a given path.
 */
function getElementAtPath(root, path) {
  var subject = root;
  for (var i = 0; i < path.length; i++) {
    if (subject == null) {
      break;
    }
    subject = subject[path[i]];
  }
  return subject;
}